import styled from "styled-components/macro";

export const CreditCardsStyle = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
`;
